import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { I18nProvider } from "@/i18n";
import Home from "@/pages/Home";
import QuoteWizard from "@/pages/QuoteWizard";
import Summary from "@/pages/Summary";
import MyQuotes from "@/pages/MyQuotes";
import AdminLogin from "@/pages/admin/AdminLogin";
import { AdminShell, ProtectedRoute } from "@/pages/admin/AdminShell";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import Pricing from "@/pages/admin/Pricing";
import Settings from "@/pages/admin/Settings";
import QuoteEdit from "@/pages/admin/QuoteEdit";
import Users from "@/pages/admin/Users";
import Subscriptions from "@/pages/admin/Subscriptions";
import Crm from "@/pages/admin/Crm";
import ProLanding from "@/pages/ProLanding";
import DevisPro from "@/pages/DevisPro";
import Partners from "@/pages/admin/Partners";
import RootLogin from "@/pages/root/RootLogin";
import { RootShell, RootProtected } from "@/pages/root/RootShell";
import RootAccounts from "@/pages/root/RootAccounts";

const Protected = ({ children }) => (
  <ProtectedRoute>
    <AdminShell>{children}</AdminShell>
  </ProtectedRoute>
);

const RootGuard = ({ children }) => (
  <RootProtected>
    <RootShell>{children}</RootShell>
  </RootProtected>
);

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/quote/:category" element={<QuoteWizard />} />
          <Route path="/summary/:id" element={<Summary />} />
          <Route path="/quotes" element={<MyQuotes />} />
          <Route path="/p/:slug" element={<ProLanding />} />
          <Route path="/devis/:slug" element={<DevisPro />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<Protected><AdminDashboard /></Protected>} />
          <Route path="/admin/users" element={<Protected><Users /></Protected>} />
          <Route path="/admin/subscriptions" element={<Protected><Subscriptions /></Protected>} />
          <Route path="/admin/pricing" element={<Protected><Pricing /></Protected>} />
          <Route path="/admin/crm" element={<Protected><Crm /></Protected>} />
          <Route path="/admin/settings" element={<Protected><Settings /></Protected>} />
          <Route path="/admin/quote/:id" element={<Protected><QuoteEdit /></Protected>} />
          <Route path="/root" element={<RootLogin />} />
          <Route path="/root/accounts" element={<RootGuard><RootAccounts /></RootGuard>} />
          <Route path="/root/partners" element={<RootGuard><Partners /></RootGuard>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
